import { render, staticRenderFns } from "./blockTilesSettings.vue?vue&type=template&id=1fc4e970&scoped=true&"
import script from "./blockTilesSettings.vue?vue&type=script&lang=js&"
export * from "./blockTilesSettings.vue?vue&type=script&lang=js&"
import style0 from "./blockTilesSettings.vue?vue&type=style&index=0&id=1fc4e970&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1fc4e970",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VHover,VIcon,VSheet})
